import Rails from "@rails/ujs"
import { Controller } from "stimulus";

function validate_email(email) {
  var regex = /^([a-zA-Z0-9._+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function skipObjectIfExists(optionObject, value) {
  return $(optionObject).find('option[value=' + value + ']').length > 0;
}

function validate_phone(phone) {
  return (phone.replace(/[_-]/gi, '').length == 10);
}

function correctDateFormat(date) {
  return date.toLocaleDateString();
}

function getDateInterval(from, to) {
  var res = '';
  if (from != null) {
    res += " from " + correctDateFormat(from);
  }

  if (to != null) {
    res += " until " + correctDateFormat(to);
  }
  return res;
}

function messageElementFor(element) {
  let messageId = $(element).data('message-id');
  return messageId ? document.getElementById(messageId) : null;
}

function defaultMessageFor(element) {
  if (!element) {
    return '';
  }

  let messageElement = messageElementFor(element);
  let defaultText = messageElement ? messageElement.dataset.defaultText : '';
  let errorText = messageElement ? messageElement.dataset.errorText : '';
  if ($(element).attr('aria-invalid') == 'true' && errorText) {
    return errorText;
  }
  if (element.disabled) {
    return $(element).data('disabled-message') || defaultText;
  }

  return $(element).data('help-text') || defaultText;
}

function setFieldMessage(element, message = null, tone = 'default') {
  let messageElement = messageElementFor(element);
  if (!messageElement) {
    return;
  }

  let text = message === null ? defaultMessageFor(element) : message;
  messageElement.innerHTML = text;
  messageElement.className = 'form-text student-field-message';

  if (tone === 'error') {
    messageElement.classList.add('text-danger', 'invalid-feedback-custom', 'd-block');
  } else if (tone === 'info') {
    messageElement.classList.add('text-info', 'd-block');
  } else {
    messageElement.classList.add('text-muted');
  }
}

function setInvalidState(element, invalid) {
  if (invalid) {
    $(element).attr('aria-invalid', 'true');
  } else {
    $(element).removeAttr('aria-invalid');
  }
  $(element).closest('.form-group').toggleClass('has-error', invalid);
}

function clearFieldState(element) {
  setInvalidState(element, false);
  setFieldMessage(element);
}

function setFieldState(element, message, invalid = false, tone = invalid ? 'error' : 'default') {
  setInvalidState(element, invalid);
  setFieldMessage(element, message, tone);
}

function togglePasswordButtons(fieldSelector, showId, hideId) {
  let field = $(fieldSelector);
  let showButton = $('#' + showId);
  let hideButton = $('#' + hideId);

  if (field.val().length > 0) {
    field.siblings('.input-group-append').show();
    let isVisible = field.attr('type') == 'text';
    showButton.toggleClass('d-none', isVisible);
    hideButton.toggleClass('d-none', !isVisible);
    showButton.attr('aria-pressed', 'false');
    hideButton.attr('aria-pressed', isVisible ? 'true' : 'false');
  } else {
    field.siblings('.input-group-append').hide();
    showButton.addClass("d-none").attr('aria-pressed', 'false');
    hideButton.addClass("d-none").attr('aria-pressed', 'false');
  }
}

export default class extends Controller {
  static targets = ["school", "instructor", "semester", "course", "group", "accessCode", "username",
                    "password", "confirmPassword", "firstName", "lastName", "email", "confirmEmail", "phone", "terms", "submit",
                    "verificationContainer", "sendCodeButton", "sendCodeResult", "emailCode", "status"];

  connect() {
    this.syncAllMessages();
    this.updatePasswordToggleButtons();
  }

  syncAllMessages() {
    [this.schoolTarget, this.instructorTarget, this.semesterTarget, this.courseTarget, this.groupTarget,
     this.accessCodeTarget, this.usernameTarget, this.passwordTarget, this.confirmPasswordTarget,
     this.firstNameTarget, this.lastNameTarget, this.emailTarget, this.confirmEmailTarget,
     this.phoneTarget, this.termsTarget, this.emailCodeTarget].forEach((element) => {
      setFieldMessage(element);
    });
  }

  announceStatus(message) {
    if (this.hasStatusTarget && message) {
      this.statusTarget.textContent = message;
    }
  }

  setAvailability(element, enabled, announcement = null) {
    let wasDisabled = element.disabled;
    element.disabled = !enabled;
    setFieldMessage(element);
    if (!enabled) {
      setInvalidState(element, false);
    } else if (wasDisabled && announcement) {
      this.announceStatus(announcement);
    }
  }

  toggleFieldVisibility(element, visible) {
    let messageElement = messageElementFor(element);
    $(element).closest('.form-group').toggle(visible);
    if (messageElement) {
      $(messageElement).toggle(visible);
    }
  }

  toggleNewUserFields(visible) {
    $('[data-new-user-field="1"]').each((idx, element) => {
      this.toggleFieldVisibility(element, visible);
      $(element).prop('required', visible);
    });
  }

  updatePasswordToggleButtons() {
    togglePasswordButtons('#student_password', 'password-visibility-true', 'password-visibility-false');
    togglePasswordButtons('#student_confirm_password', 'c-password-visibility-true', 'c-password-visibility-false');
  }

  disableAccountDetails() {
    this.setAvailability(this.usernameTarget, false);
    this.setAvailability(this.passwordTarget, false);
    this.setAvailability(this.confirmPasswordTarget, false);
    this.setAvailability(this.firstNameTarget, false);
    this.setAvailability(this.lastNameTarget, false);
    this.setAvailability(this.emailTarget, false);
    this.setAvailability(this.confirmEmailTarget, false);
    this.setAvailability(this.phoneTarget, false);
    this.setAvailability(this.termsTarget, false);
    this.submitTarget.disabled = true;
    this.verificationContainerTarget.hidden = true;
    this.setAvailability(this.emailCodeTarget, false);
    this.sendCodeResultTarget.textContent = 'If your username already exists, send a verification code to continue.';
  }

  updateTerms(event) {
    let termsTarget = this.termsTarget;

    if (termsTarget.checked) {
      clearFieldState(termsTarget);
      this.announceStatus('Terms accepted. You can submit your registration.');
    } else {
      setFieldState(termsTarget, 'Review and accept the Terms of Service and Privacy Policy to submit registration.');
    }
  }

  updatePhone(event) {
    let phoneTarget = this.phoneTarget;
    let termsTarget = this.termsTarget;
    let submitTarget = this.submitTarget;

    if (validate_phone(phoneTarget.value)) {
      clearFieldState(phoneTarget);
      this.setAvailability(termsTarget, true, 'Phone number accepted. The Terms of Service checkbox is now available.');
      submitTarget.disabled = false;
    } else {
      setFieldState(phoneTarget, 'Enter a 10-digit phone number in the format 999-999-9999.', phoneTarget.value.length > 0);
      this.setAvailability(termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateConfirmEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    if (validate_email(emailTarget.value) && emailTarget.value == confirmEmailTarget.value) {
      clearFieldState(confirmEmailTarget);
      this.setAvailability(phoneTarget, true, 'Email confirmed. The phone number field is now available.');
    } else {
      setFieldState(confirmEmailTarget, 'Email addresses must match before you can continue.', confirmEmailTarget.value.length > 0);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateEmail(event) {
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;

    let locked = $(emailTarget).data('locked') == '1';

    if (validate_email(emailTarget.value) && !locked) {
      clearFieldState(emailTarget);
      this.setAvailability(confirmEmailTarget, true, 'Email accepted. Confirm your email address to continue.');
    } else {
      setFieldState(emailTarget, 'Enter a valid email address.', emailTarget.value.length > 0);
      this.setAvailability(confirmEmailTarget, false);
    }
  }

  updateLastName(event) {
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    if (lastNameTarget.value.length >= 1) {
      clearFieldState(lastNameTarget);
      this.setAvailability(emailTarget, true, 'Last name accepted. The email field is now available.');
    } else {
      setFieldState(lastNameTarget, 'Enter your last name.', false);
      this.setAvailability(emailTarget, false);
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateFirstName(event) {
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    if (firstNameTarget.value.length >= 1) {
      clearFieldState(firstNameTarget);
      this.setAvailability(lastNameTarget, true, 'First name accepted. The last name field is now available.');
    } else {
      setFieldState(firstNameTarget, 'Enter your first name.', false);
      this.setAvailability(lastNameTarget, false);
      this.setAvailability(emailTarget, false);
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateConfirmPassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    this.updatePasswordToggleButtons();

    if (passwordTarget.value.length >= 8 && passwordTarget.value == confirmPasswordTarget.value) {
      clearFieldState(confirmPasswordTarget);
      this.setAvailability(firstNameTarget, true, 'Password confirmed. The first name field is now available.');
    } else {
      setFieldState(confirmPasswordTarget, 'Passwords must match before you can continue.', confirmPasswordTarget.value.length > 0);
      this.setAvailability(firstNameTarget, false);
      this.setAvailability(lastNameTarget, false);
      this.setAvailability(emailTarget, false);
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updatePassword(event) {
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    this.updatePasswordToggleButtons();

    if (passwordTarget.value.length >= 8) {
      clearFieldState(passwordTarget);
      this.setAvailability(confirmPasswordTarget, true, 'Password accepted. Confirm your password to continue.');
    } else {
      setFieldState(passwordTarget, 'Create a password with at least 8 characters.', passwordTarget.value.length > 0);
      this.setAvailability(confirmPasswordTarget, false);
      this.setAvailability(firstNameTarget, false);
      this.setAvailability(lastNameTarget, false);
      this.setAvailability(emailTarget, false);
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateUsername(event) {
    let usernameTarget = this.usernameTarget;
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    if (usernameTarget.value.length >= 5) {
      clearFieldState(usernameTarget);
      this.setAvailability(passwordTarget, true, 'Username accepted. The password field is now available.');
    } else {
      setFieldState(usernameTarget, 'Use at least 5 lowercase letters or numbers.', usernameTarget.value.length > 0);
      this.setAvailability(passwordTarget, false);
      this.setAvailability(confirmPasswordTarget, false);
      this.setAvailability(firstNameTarget, false);
      this.setAvailability(lastNameTarget, false);
      this.setAvailability(emailTarget, false);
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  updateEmailCode(event) {
    let emailCodeTarget = this.emailCodeTarget;
    let phoneTarget = this.phoneTarget;

    if (emailCodeTarget.value.length == 10) {
      clearFieldState(emailCodeTarget);
      this.setAvailability(phoneTarget, true, 'Verification code accepted. The phone number field is now available.');
    }
    else {
      setFieldState(emailCodeTarget, 'Enter the full verification code sent to your email address.', emailCodeTarget.value.length > 0);
      this.setAvailability(phoneTarget, false);
    }
  }

  sendCode(event) {
    let emailTarget = this.emailTarget;
    let usernameTarget = this.usernameTarget;
    let sendCodeResultTarget = this.sendCodeResultTarget;
    let emailCodeTarget = this.emailCodeTarget;

    if (validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('username', usernameTarget.value);
      data.append('email', emailTarget.value);

      Rails.ajax({
        url: '/email_verification_codes/send_code',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.success) {
            if (data.already_sent) {
              sendCodeResultTarget.textContent = "A verification code was already sent recently. Check the email address associated with your account.";
            } else {
              sendCodeResultTarget.textContent = "Verification code sent. Check the email address associated with your account.";
            }
            this.setAvailability(emailCodeTarget, true);
            this.announceStatus('Verification code sent. Enter the code to continue registration.');
            emailCodeTarget.focus();
          } else {
            sendCodeResultTarget.innerHTML = data.error || "This email address is not associated with your account. Please contact support at <a href=\"mailto:support@connect4education.com\">support@connect4education.com</a>.";
            this.setAvailability(emailCodeTarget, false);
            setFieldState(emailCodeTarget, 'Send a verification code to enable this field.');
            this.announceStatus('Verification code could not be sent. Review the email address and try again.');
          }
        },
        error: () => {
          sendCodeResultTarget.innerHTML = "We could not send the verification code. Please contact support at <a href=\"mailto:support@connect4education.com\">support@connect4education.com</a>.";
          this.setAvailability(emailCodeTarget, false);
          setFieldState(emailCodeTarget, 'Send a verification code to enable this field.');
          this.announceStatus('Verification code could not be sent. Please contact support.');
        }
      })
    } else {
      setFieldState(emailTarget, 'Enter a valid email address before requesting a verification code.', true);
      this.announceStatus('Enter a valid email address before requesting a verification code.');
    }

    event.preventDefault();
  }

  checkEmail(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    let existingUser = $(usernameTarget).data('existing-user');

    if (!existingUser && validate_email(emailTarget.value)) {
      let data = new FormData();
      data.append('field', 'email');
      data.append('value', emailTarget.value);

      Rails.ajax({
        url: '/api/check_moodle_field',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.exists) {
            setFieldState(emailTarget, 'This email is already associated with an account under a different username.', true);
            this.setAvailability(confirmEmailTarget, false);
            this.setAvailability(phoneTarget, false);
            this.setAvailability(this.termsTarget, false);
            submitTarget.disabled = true;
            this.announceStatus('This email address is already associated with a different username.');
          } else {
            clearFieldState(emailTarget);
            this.setAvailability(confirmEmailTarget, true, 'Email accepted. Confirm your email address to continue.');
          }
        }
      })
    } else {
      if (!existingUser) {
        setFieldState(emailTarget, 'Enter a valid email address.', emailTarget.value.length > 0);
      } else {
        clearFieldState(emailTarget);
      }
      this.setAvailability(confirmEmailTarget, false);
      this.setAvailability(phoneTarget, false);
      this.setAvailability(this.termsTarget, false);
      submitTarget.disabled = true;
    }
  }

  checkUsername(event) {
    let usernameTarget = this.usernameTarget;
    let emailTarget = this.emailTarget;
    let verificationContainerTarget = this.verificationContainerTarget;

    let data = new FormData();
    usernameTarget.value = usernameTarget.value.toLocaleLowerCase().replace(/[^a-z0-9]/gi,'');
    data.append('field', 'username');
    data.append('value', usernameTarget.value);

    if (usernameTarget.value.length >= 5) {
      Rails.ajax({
        url: '/api/check_moodle_field',
        type: "POST",
        data: data,
        success: (data) => {
          if (data.exists) {
            let errorMessage = data.error_msg;
            setFieldState(usernameTarget, errorMessage, false, 'info');
            if (errorMessage.indexOf('Username already exists') > -1){
              verificationContainerTarget.hidden = false;
              this.setAvailability(emailTarget, true, 'Existing account found. Enter your email address, then send a verification code.');
              $(usernameTarget).data('existing-user', true);
              this.toggleNewUserFields(false);
              this.announceStatus('Existing account found. Email verification is now required.');
            }
          } else {
            clearFieldState(usernameTarget);
            verificationContainerTarget.hidden = true;
            this.setAvailability(emailTarget, false);
            this.setAvailability(this.emailCodeTarget, false);
            $(usernameTarget).data('existing-user', false);
            this.toggleNewUserFields(true);
          }
        }
      })
    } else {
      clearFieldState(usernameTarget);
      verificationContainerTarget.hidden = true;
      this.setAvailability(emailTarget, false);
      this.setAvailability(this.emailCodeTarget, false);
      $(usernameTarget).data('existing-user', false);
      this.toggleNewUserFields(true);
      if (usernameTarget.value.length > 0) {
        setFieldState(usernameTarget, 'Use at least 5 lowercase letters or numbers.', true);
      }
    }
  }

  updateAccessCode(event) {
    let accessCodeTarget = this.accessCodeTarget;
    if (accessCodeTarget.value.length < 3) {
      setFieldMessage(accessCodeTarget);
      return;
    }
    let courseTarget = this.courseTarget;
    let usernameTarget = this.usernameTarget;
    let passwordTarget = this.passwordTarget;
    let confirmPasswordTarget = this.confirmPasswordTarget;
    let firstNameTarget = this.firstNameTarget;
    let lastNameTarget = this.lastNameTarget;
    let emailTarget = this.emailTarget;
    let confirmEmailTarget = this.confirmEmailTarget;
    let phoneTarget = this.phoneTarget;
    let submitTarget = this.submitTarget;

    let data = new FormData();
    data.append('access_code', accessCodeTarget.value);
    data.append('course_request_id', courseTarget.value);

    Rails.ajax({
      url: '/access_codes/verify',
      type: "POST",
      data: data,
      success: (data) => {
        if (!data.valid) {
          if (data.access_code_error) {
            setFieldState(accessCodeTarget, data.access_code_error, true);
            this.setAvailability(usernameTarget, false);
            this.setAvailability(passwordTarget, false);
            this.setAvailability(confirmPasswordTarget, false);
            this.setAvailability(firstNameTarget, false);
            this.setAvailability(lastNameTarget, false);
            this.setAvailability(emailTarget, false);
            this.setAvailability(confirmEmailTarget, false);
            this.setAvailability(phoneTarget, false);
            this.setAvailability(this.termsTarget, false);
            submitTarget.disabled = true;
            this.announceStatus('The access code is invalid. Review the code and try again.');
          }
        } else {
          clearFieldState(accessCodeTarget);
          this.setAvailability(usernameTarget, true, 'Access code accepted. The username field is now available.');
        }
      }
    })
  }

  updateSchool(event) {
    let school = this.schoolTarget.value;
    let instructor = this.instructorTarget;
    instructor.value = null;

    if (school == ''){
      setFieldState(this.schoolTarget, 'Choose your school to unlock the instructor list.', false);
    } else {
      clearFieldState(this.schoolTarget);
    }

    this.clearSemester()
    this.clearCourse()
    this.clearInstructor()

    let instructors = select_data.filter(function(el){ return el[3][1] == school })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Instructor...";
    instructor.appendChild(opt);
    instructors.forEach(function(el){
      if (skipObjectIfExists(instructor, el[1][1])) return;
      var opt = document.createElement('option');
      opt.value = el[1][1];
      opt.innerHTML = el[1][0];
      instructor.appendChild(opt);
    })
    $('.lti-course-message').hide();

    this.setAvailability(instructor, !!school, school ? 'School selected. The instructor field is now available.' : null);
  }


  updateInstructor(event) {
    let semester = this.semesterTarget;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearSemester()
    this.clearCourse()


    let semesters = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Semester...";
    semester.appendChild(opt);
    semesters.forEach(function(el){
      if (skipObjectIfExists(semester, el[2][1])) return;
      var opt = document.createElement('option');
      opt.value = el[2][1];
      opt.innerHTML = el[2][0];
      semester.appendChild(opt);
    })
    $('.lti-course-message').hide();
    $('.registration-date-message').hide();

    this.setAvailability(semester, !!instructor, instructor ? 'Instructor selected. The semester field is now available.' : null);
  }

  updateSemester(event) {
    let course = this.courseTarget;
    let semester = this.semesterTarget.value;
    let instructor = this.instructorTarget.value;
    let school = this.schoolTarget.value;

    this.clearCourse()

    let courses = select_data.filter(function(el){ return el[3][1] == school && el[1][1] == instructor && el[2][1] == semester  })
    var opt = document.createElement('option');
    opt.value = '';
    opt.innerHTML = "Select Course...";
    course.appendChild(opt);
    courses.forEach(function(el){
      var opt = document.createElement('option');
      opt.value = el[0][1];
      opt.innerHTML = el[0][6].concat("-", el[0][7], "-", el[0][8], "-", el[0][0]);
      course.appendChild(opt);
    })
    $('.lti-course-message').hide();
    $('.registration-date-message').hide();

    this.setAvailability(course, !!semester, semester ? 'Semester selected. The course field is now available.' : null);

  }

  updateCourse(event){
    clearFieldState(this.courseTarget);
    let course = this.courseTarget.value;
    if (!course) {
      $('.js-course-group-id').hide()
      $('.lti-course-message').hide();
      $('.registration-details').hide();
      $('.registration-date-message').hide();
      this.setAvailability(this.groupTarget, false);
      this.setAvailability(this.accessCodeTarget, false);
      this.disableAccountDetails();
      return

    }
    let accessCodeTarget = this.accessCodeTarget;
    let groupTarget = this.groupTarget;
    let course_value = select_data.filter(function(el){ return el[0][1] == course })[0];

    let start_date = new Date(course_value[0][3].replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let end_date = new Date((new Date(course_value[0][4].replace(/\-/g,'\/').replace(/[T|Z]/g,' '))).setHours(23,59,59,999));
    let isSuccess = true;
    let errorMessage = ''
    let startValid = course_value[0][9] === "true"
    let endValid = course_value[0][10] === "true"

    // uses constant allowLate declared in app/views/students/new.html.erb
    if (!allowLate) {
      if (!startValid) {
        isSuccess = false;
        errorMessage = 'The registration period for this course has not started yet. The registration period runs' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor';
      } else if (!endValid) {
        isSuccess = false;
        errorMessage = 'The registration period for this course has ended. The registration period runs' + getDateInterval(start_date, end_date) + '. Should you require further assistance, please contact your instructor.';
      }
    }

    if (isSuccess) {
      if (course_value[0][2] == 'no_lti' || course_value[0][2] == ''){
        $('.lti-course-message').hide();
        let data = new FormData();
        $("#loader").show()
        Rails.ajax({
          url: "/students/associated_course_groups?course_request_id=" + course,
          type: "GET",
          success: (data) => {
            $("#loader").hide()
            if (data.valid) {
              $('.registration-details').show();
              if (data.groups_ids.length > 0) {
                $('.js-course-group-id').css('display', 'flex')
                $(groupTarget).empty();
                $(groupTarget).append($('<option>', { value: '', text : 'Select Group...' }));
                $.each(data.groups_ids, function (i, item) {
                  $(groupTarget).append($('<option>', {
                    value: item[0],
                    text : item[1]
                  }));
                });
                this.setAvailability(groupTarget, true, 'Course selected. Choose a group to continue.');
                this.setAvailability(accessCodeTarget, false);
              } else {
                $('.js-course-group-id').hide()
                this.setAvailability(groupTarget, false);
                this.setAvailability(accessCodeTarget, true, 'Course selected. The access code field is now available.');
              }
            } else {
              $('.js-course-group-id').hide()
              this.setAvailability(groupTarget, false);
              setFieldState(this.courseTarget, data.associated_course_groups_error, true);
              this.setAvailability(accessCodeTarget, false);
              this.announceStatus('The selected course is unavailable for registration.');
            }
          }
        })
      }
      else {
        $('.js-course-group-id').hide()
        $('.lti-course-message').show();
        $('.registration-details').hide();
        this.setAvailability(groupTarget, false);
        this.setAvailability(accessCodeTarget, false);
        this.disableAccountDetails();
        this.announceStatus('This course must be accessed through your school learning management system.');
      }
      $('.registration-date-message').hide();
    } else {
      if (course_value[0][2] == 'deep_link' || course_value[0][2] == 'simple'){
        $('.lti-course-message').show();
        $('.registration-date-message').hide();
        this.announceStatus('This course must be accessed through your school learning management system.');
      } else {
        $('.registration-date-message').html(errorMessage);
        $('.lti-course-message').hide();
        $('.registration-date-message').show();
        this.announceStatus(errorMessage);
      }
      $('.registration-details').hide();
      $('.js-course-group-id').hide();
      this.setAvailability(groupTarget, false);
      this.setAvailability(accessCodeTarget, false);
      this.disableAccountDetails();
    }
  }

  updateGroup(event){
    let accessCodeTarget = this.accessCodeTarget;
    let group = this.groupTarget.value;
    $('.registration-details').show();
    this.setAvailability(accessCodeTarget, !!group, group ? 'Group selected. The access code field is now available.' : null);
  }

  clearInstructor(){
    let instructor = this.instructorTarget;
    instructor.value = '';
    this.setAvailability(instructor, false);
    instructor.innerHTML = '';
    return true;
  }

  clearSemester(){
    let semester = this.semesterTarget;
    semester.value = null;
    this.setAvailability(semester, false);
    semester.innerHTML = '';
  }

  clearCourse(){
    let course = this.courseTarget;
    let group = this.groupTarget;
    course.value = null;
    this.setAvailability(course, false);
    course.innerHTML = '';
    group.value = null;
    this.setAvailability(group, false);
    group.innerHTML = '';
    this.setAvailability(this.accessCodeTarget, false);
    this.disableAccountDetails();
  }
}
